angular.module('zc')
  .component('zcSiteReportGlossary', {
    templateUrl: '/templates/projects.site_reports/glossary.html',
  });



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.site_reports/glossary.controller.js